module.exports = new Promise((resolve) => {
    const baseUrl = (window.RUNTIME && window.RUNTIME['BILLRATECALCULATOR_REMOTE_URL']) || '';

    if (!baseUrl) {
      console.error('Missing bill rate calculator remote URL');
      return resolve({
        get: () => Promise.reject(new Error('Missing bill rate calculator remote URL')),
        init: () => {}
      });
    }

    const remoteUrl = (() => {
      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}t=${Date.now()}`;
    })();

    if (window['billRateCalculator']) {
      const existingContainer = window['billRateCalculator'];
      return resolve({
        get: (request) => existingContainer.get(request),
        init: (arg) => {
          try {
            return existingContainer.init(arg);
          } catch (_) {}
        }
      });
    }

    const existingScript = document.querySelector('script[data-mf-remote="billRateCalculator"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        const container = window['billRateCalculator'];
        if (!container) {
          return resolve({
            get: () => Promise.reject(new Error('billRateCalculator not found')),
            init: () => {}
          });
        }

        resolve({
          get: (request) => container.get(request),
          init: (arg) => {
            try {
              return container.init(arg);
            } catch (_) {}
          }
        });
      });

      existingScript.addEventListener('error', () => {
        resolve({
          get: () => Promise.reject(new Error('Failed loading bill rate calculator remote')),
          init: () => {}
        });
      });

      return;
    }

    const el = document.createElement('script');
    el.src = remoteUrl;
    el.type = 'text/javascript';
    el.async = true;
    el.crossOrigin = 'anonymous';
    el.dataset.mfRemote = 'billRateCalculator';

    el.onload = () => {
      const container = window['billRateCalculator'];
      if (!container) {
        console.error('Remote container "billRateCalculator" not found on window');
        return resolve({
          get: () => Promise.reject(new Error('billRateCalculator not found')),
          init: () => {}
        });
      }

      resolve({
        get: (request) => container.get(request),
        init: (arg) => {
          try {
            return container.init(arg);
          } catch (_) {}
        }
      });
    };

    el.onerror = () => {
      console.error('Failed to load remoteEntry:', remoteUrl);
      el.remove();
      resolve({
        get: () => Promise.reject(new Error('Failed loading bill rate calculator remote')),
        init: () => {}
      });
    };

    document.head.appendChild(el);
  })
;